import moment from 'moment';
import { KontentProductDTO } from './restApplicationClient';

const MAX_PROJECT_NAME_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 2000;
const MAX_NAME_WITHOUT_TIME_LENGTH = 86;
const MANY_CONTENTS_MARKER = '_MANY_CONTENTS_';

/**
 * Removes all illicit characters from value
 *
 * @param name - value
 *
 * @returns {string} - value with removed illicit characters
 */
function removeIllicitCharacters(name: string): string {
  return name.replace(/[\t",/:<>?{|}]/g, '');
}

/**
 * Returns project name for single content item
 *
 * @param prefix - user project name prefix
 * @param projectName - kentico project name
 * @param contentName - content name
 *
 * @returns {string} - project name for single content item
 */
export function generateProjectNameForSingleItem(prefix: string, projectName: string, contentName: string): string {
  let name = '';
  name += `${removeIllicitCharacters(prefix)}_`;
  name += `${removeIllicitCharacters(projectName)}_`;
  name += removeIllicitCharacters(contentName);
  return name.slice(0, MAX_PROJECT_NAME_LENGTH);
}

/**
 * Returns project name for multiple content items
 *
 * @param prefix - user project name prefix
 *
 * @returns {string} - project name for multiple content items
 */
export function generateProjectNameForMultipleItems(prefix: string): string {
  let name = '';
  name += removeIllicitCharacters(prefix);
  name += MANY_CONTENTS_MARKER;
  name.slice(0, MAX_NAME_WITHOUT_TIME_LENGTH);
  name += moment().format('YYYYMMDDhhmmss');
  return name;
}

/**
 * Returns description for single content item
 *
 * @param contentName - content name
 *
 * @returns {string} - description for single content item
 */
export function generateDescriptionForSingleItem(contentName: string): string {
  return removeIllicitCharacters(contentName).slice(0, MAX_DESCRIPTION_LENGTH);
}

/**
 * Returns desecription for multiple content items
 *
 * @param content - array of selected content items
 *
 * @returns {string} - desecription for multiple content items
 */
export function generateDescriptionForMultipleItems(content: KontentProductDTO[]): string {
  let description = '';
  content.forEach(({ name }, index) => {
    description += content.length - 1 !== index ? `${removeIllicitCharacters(name)}, ` : removeIllicitCharacters(name);
  });
  return description.slice(0, MAX_DESCRIPTION_LENGTH);
}
